import {configureStore} from "@reduxjs/toolkit"

import userReducer from "./user/userData"

export default configureStore({
    reducer:{
        userId:userReducer
    }
})